module.exports = __webpack_public_path__ + "img/gnzs16.75b5b009.png";